<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" width="250px" @close="close" :close-on-click-modal="false">
    <el-form ref="form" :model="form" label-width="90px"  v-loading="loading" :element-loading-text="elementLoadingText">
      <el-tabs v-model="bindingType" @tab-click="selectBindingType">
        <el-tab-pane label="已有账号" name="0">  
          <el-row>
            <el-col :span="24">
              <div class="el-form-item is-required">
                <label for="mobile" class="el-form-item__label" style="width: 100px;">用&nbsp;&nbsp;户&nbsp;&nbsp;名：</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <div class="el-input">
                    <input type="text"  placeholder="请输入用户名" v-model="form.mobile" autocomplete="off" class="el-input__inner">
                  </div>
                </div>
              </div>
            </el-col>   
          </el-row>
          <el-row>       
            <el-col :span="24">
              <div class="el-form-item is-required">
                <label for="password" class="el-form-item__label" style="width: 100px;">密&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;码：</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <div class="el-input newPassword">
                    <input :type="passwordType" placeholder="请输入登录密码" v-model="form.password" autocomplete="off" class="el-input__inner">
                    <img v-if="passwordType === 'password'" src="https://file-sz.fjjykj.com.cn/Supply/se21a0a57445b47f30e25aa15ddae8d94.png" @click="handlePassword">
                    <img v-else src="https://file-sz.fjjykj.com.cn/Supply/s863608c680ccd0900caff867a42cf508.png" @click="handlePassword">                 
                  </div>
                </div>
              </div>            
            </el-col>     
          </el-row> 
        </el-tab-pane>
        <el-tab-pane label="新账号" name="1">  
          <el-row>
            <el-col :span="24">
              <div class="el-form-item is-required">
                <label for="mobile" class="el-form-item__label" style="width: 100px;">手机号码：</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <div class="el-input">
                    <input type="text"  placeholder="请输入手机号码" v-model="form.mobile" autocomplete="off" class="el-input__inner">
                  </div>
                </div>
              </div>
            </el-col>   
          </el-row>
          <el-row>       
            <el-col :span="24">
              <div class="el-form-item is-required">
                <label for="code" class="el-form-item__label" style="width: 100px;">验&nbsp;&nbsp;证&nbsp;&nbsp;码：</label>
                <div class="el-form-item__content" style="margin-left: 100px;height:36px;">
                  <div class="el-input code">                  
                    <input type="text" placeholder="请输入图形验证码" v-model="form.code" autocomplete="off" class="el-input__inner">   
                    <img :src="codeUrl" @click="refreshCaptcha">              
                  </div>
                </div>
              </div>          
            </el-col>     
          </el-row>    
          <el-row>       
            <el-col :span="24">
              <div class="el-form-item is-required">
                <label for="shortMsgCode" class="el-form-item__label" style="width: 100px;">短&nbsp;&nbsp;信&nbsp;&nbsp;码：</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <div class="el-input shortMsgCode">                  
                    <input type="text" placeholder="请输入短信验证码" v-model="form.shortMsgCode" autocomplete="off" class="el-input__inner">
                    <div class="sendbtn" v-if="!isSendMsg" @click="toSendMsg"> {{shortMsgCodeContent}}</div>   
                    <div class="sendbtn1" v-else> {{shortMsgCodeContent}}({{countDown}})</div>   
                  </div>
                </div>
              </div>          
            </el-col>     
          </el-row>         
          <el-row>       
            <el-col :span="24">
              <div class="el-form-item is-required">
                <label for="password" class="el-form-item__label" style="width: 100px;">密&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;码：</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <div class="el-input newPassword">
                    <input :type="passwordType" placeholder="请输入数字、字母、特殊字符组合密码" v-model="form.password" autocomplete="off" class="el-input__inner">
                    <img v-if="passwordType === 'password'" src="https://file-sz.fjjykj.com.cn/Supply/se21a0a57445b47f30e25aa15ddae8d94.png" @click="handlePassword">
                    <img v-else src="https://file-sz.fjjykj.com.cn/Supply/s863608c680ccd0900caff867a42cf508.png" @click="handlePassword">                 
                  </div>
                </div>
              </div>            
            </el-col>     
          </el-row>         
          <el-row>       
            <el-col :span="24">
              <div class="el-form-item is-required">
                <label for="password_confirmation" class="el-form-item__label" style="width: 100px;">确认密码：</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <div class="el-input">
                    <input type="password" placeholder="请输入确认密码" v-model="form.password_confirmation" autocomplete="off" class="el-input__inner">
                  </div>
                </div>
              </div>  
            </el-col>     
          </el-row>   
        </el-tab-pane>  
      </el-tabs>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="closeBtn"  @click="close">取 消</el-button>
      <el-button class="saveBtn" type="primary" @click="validateData">绑 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import store from '@/store'
import { getCaptchaImage, sendMsg, bindingUser } from '@/api/login'
import axios from 'axios'
export default {
  name: 'BindingUser',
  components: {  },
  data() {
    return {     
      form: { 
        mobile:'',
        password: '',
        password_confirmation: '',    
        shortMsgCode: '',     
        code:'',  
        uniqueCode:'',
        openId:'',
        nickName:'',
        avatar:'',
        bindingType:0 
      },
      codeUrl:'',
      title: '',
      passwordType:'password',
      dialogFormVisible: false,
      loading:false,
      elementLoadingText:"数据提交中,请稍后...",
      shortMsgCodeContent:'获取验证码',
      isSendMsg:false,
      countDown:0,
      bindingType:'0'
    }
  },
  created() {},
  mounted() {  
  },
  methods: {
    async showEdit(row) {  
      this.title = '绑定用户'     
      this.form.openId = row.openId;
      this.form.avatar = row.avatar;
      this.form.nickName = row.nickName;
      this.dialogFormVisible = true        
    },  
    selectBindingType()
    {
      if((this.bindingType==1||this.bindingType=='1')&&!this.codeUrl)
      {
        this.refreshCaptcha();       
      }
    },
    handlePassword() {
      this.passwordType === 'password'
        ? (this.passwordType = '')
        : (this.passwordType = 'password')    
    },
    refreshCaptcha()
    {    
      getCaptchaImage().then(response => {
          this.codeUrl ="data:image/jpg;base64," + response.data.result.image;
          this.form.uniqueCode = response.data.result.guid;
      }).catch(error => {     
        this.$message({
          message: '抱歉，服务器开了个小差！',
          type: 'error',
          customClass: 'c-msg',
          duration: 0,
          showClose: true
        })
        Promise.reject(error)
      })
    },
    async toSendMsg()
    {
      if (!this.form.mobile) {    
        this.$message.error('手机号码不能为空!')
        return
      }  
      var myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
      if(!myreg.test(this.form.mobile))
      {
        this.$message({ message: '手机号码格式不正确', type: 'error', customClass: 'c-msg' })
        return;
      }       
      if(this.isSendMsg)return;
      var _this=this;
      this.loading=true;
      this.elementLoadingText="获取短信验证码中,请稍后..."
      await sendMsg({ mobile:this.form.mobile }).then(response => {        
          _this.loading=false;
          if(response.data.success)
          {
            _this.isSendMsg=true;     
            _this.shortMsgCodeContent = '重新获取';  
            _this.countDown = 60;
            _this.countDownFun();
          }
          else
          {
            _this.$message({  message: response.data.error.message,type: 'error', customClass: 'c-msg',duration: 0, showClose: true })
          }
      }).catch(error => {  
        _this.loading=false;   
        const { response, message } = error
        var msg = '抱歉，服务器开了个小差!';
        _this.$message({  message: msg,type: 'error', customClass: 'c-msg',duration: 0, showClose: true })
      })      
    },
    countDownFun()
      {      
        if(this.countDown>0)
        {
           this.countDown--;          
           var _this=this;          
           setTimeout(() => {
              _this.countDownFun()
            }, 1000)
        }
        else 
        {
           this.isSendMsg=false;     
           this.shortMsgCodeContent = '获取验证码';
           return;
        }   
      }, 
    close() {    
      this.$refs['form'].resetFields()
      this.$emit('fetch-data')
      this.form = this.$options.data().form      
      this.dialogFormVisible = false
    },
    validateData()
    {
      var bindingType = parseInt(this.bindingType);
      if(bindingType==1)
      {
        this.form.bindingType = 1;
        if(this.form.mobile==null||this.form.mobile=='')
        {
          this.$message.error('手机号码不可为空!')
          return
        }
        var myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
        if(!myreg.test(this.form.mobile))
        {
          this.$message({ message: '手机号码格式不正确', type: 'error', customClass: 'c-msg' })
          return;
        }     
        if(this.form.code==null||this.form.code=='')
        {
          this.$message({ message: '图形验证码不可为空', type: 'error', customClass: 'c-msg' })
          return;  
        } 
        if(this.form.shortMsgCode==null||this.form.shortMsgCode=='')
        {
          this.$message({ message: '短信验证码不可为空', type: 'error', customClass: 'c-msg' })
          return;  
        }
        if(this.form.password==null||this.form.password=='')
        {
          this.$message({ message: '新密码不可为空', type: 'error', customClass: 'c-msg' })
          return;    
        }
        var txt = this.form.password;//输入框内容 trim处理两端空格
        var len = txt.length;
        var num = /\d/.test(txt);//匹配数字
        var big = /[A-Za-z]/.test(txt);//大小写字母
        var corps = /\W/.test(txt);//特殊符号
        var val = num + big + corps; //三个组合
        if(len < 6) { 
          this.$message({ message: '密码长度至少需要6位数', type: 'error', customClass: 'c-msg' })
          return;
        }
        if(val != 3) {
          this.$message({ message: '密码强度太低,需要数字、字母、特殊字符中三个的组合', type: 'error', customClass: 'c-msg' })
          return;
        }
        if(this.form.password_confirmation==null||this.form.password_confirmation=='')
        {
          this.$message({ message: '确认密码不可为空', type: 'error', customClass: 'c-msg' })
          return;    
        }
        if(this.form.password_confirmation!=this.form.password)
        {
          this.$message({ message: '两次密码不一致', type: 'error', customClass: 'c-msg' })
          return;    
        }      
      }
      else
      {
        this.form.bindingType = 0;
        if(this.form.mobile==null||this.form.mobile=='')
        {
          this.$message.error('用户名不可为空!')
          return
        }
        if(this.form.password==null||this.form.password=='')
        {
          this.$message({ message: '密码不可为空', type: 'error', customClass: 'c-msg' })
          return;    
        }
      }
      this.save();         
    },
    save() {    
      this.loading=true;
      this.elementLoadingText="数据提交中,请稍后..."
      var _this=this;
      this.$refs['form'].validate(async (valid) => {    
        if (valid) { 
          await bindingUser(this.form).then(res=>{
            debugger
            _this.loading=false;   
            if(res&&res.data&&res.data.success)
            {
              _this.$refs['form'].resetFields()              
              _this.dialogFormVisible = false     
              _this.form = this.$options.data().form
              debugger;
              var loginParam = { isSuccess:true,accessToken:res.data.result.accessToken};
              _this.$emit('bindingLogin', loginParam)
              _this.$confirm('绑定成功', '温馨提示',{type:'success'}).then(()=>
              {                 
              });   
            }    
            else
            {
               var msg='修改失败';
               if(res&&res.data&&res.data.error&&res.data.error.message)
               {
                  msg += ',原因:'+res.data.error.message;
               }
               this.$message({ message: msg, type: 'error', customClass: 'c-msg' })
            }
          })
        } else {
          _this.loading=false;
          return false
        }
      })
    },  
 
  },
}
</script>
<style>
.shortMsgCode
{
  position: relative;
}

 .sendbtn
{
    position: absolute;
    display: inline-block;
    padding: 0 0px;
    height: 35px;
    right: 20px;
    top: 0;
    line-height: 35px;
    cursor: pointer;
    color: #ff6a00;
}

.sendbtn1
{
    position: absolute;
    display: inline-block;
    padding: 0 0px;
    height: 35px;
    right: 20px;
    top: 0;
    line-height: 35px;
    cursor: not-allowed;
    color: #81807f;
}
.saveBtn
{
  background-color: #FF5E00 !important;
  border-color: #FF5E00 !important;
  color: #FFF !important;
  cursor: pointer !important;
}
.closeBtn
{
  border-color: #FF5E00 !important;
  color:#FF5E00 !important;
  cursor: pointer !important;
}
 .el-dialog__title
{
  font-size: 18px !important;
  color:#FF5E00 !important;
}

.code > input
{
 width: 225px;
 float: left;
}

.code > img
{
  float: left;
  margin-left: 5px;
  width: 80px;
  height: 35px;  
  cursor: pointer;
}

.el-radio-group .el-radio__input.is-checked .el-radio__inner
{
    background-color: #FF5E00;
    border-color: #FF5E00;
}

.newPassword
{
  position: relative;
}

.newPassword img
{
    position: absolute;
    right:20px;
    top:5px;
    width: 25px;
    height: 25px;
}
 .el-tabs__active-bar
{
    background-color: #FF5E00 !important;
}
 .el-tabs__item
{
    color: #FF5E00 !important;
    font-size: 16px;
    text-align: center;
    margin-top: 5px;
    font-weight: bold;
    font-family:PingFang SC;
}
.el-dialog__body
{
  padding-top:10px !important ;
}
</style>


// WEBPACK FOOTER //
// BindingUser.vue?3d69e4be